module.exports = __webpack_public_path__ + "img/icon-slide-next.8f4653af.svg";